module.exports = __webpack_public_path__ + "img/elisette.9b739ffc.png";